import { ChangeEvent, FC } from "react";
import classes from './addReceipt.module.scss'
import { useGlobalLoadingActions } from "../../../entities/globalLoading";
import { useGlobalMessageActions } from "../../../entities/globalMessage";
import { tutorService } from "../../../entities/tutor";
import { MyError } from "../../../shared/lib/error/MyError";
import { AuthError } from "../../../shared/lib/error/AuthError";
import { useMyActions } from "../../../entities/my";
import { RECEIPT_SAVED_EVENT } from "../../../shared/lib/const/receiptEvents";

interface IProps {
    accrualId: string;
    onSaveTrigger: () => void;
}

export const AddReceipt: FC<IProps> = ({accrualId, onSaveTrigger}) => {

    const {setIsLoading} = useGlobalLoadingActions()
    const {setGlobalMessage} = useGlobalMessageActions()
    const {setIsAuth} = useMyActions()

    const onSave = async (formData: FormData) => {
        try{
            setIsLoading(true)
            formData.append('accrual_id', String(accrualId))
            await tutorService.receiptSave(formData)
            window.dispatchEvent(new Event(RECEIPT_SAVED_EVENT))
            onSaveTrigger()
            setGlobalMessage({message: 'Успешная загрузка чека', type: 'ok'})
        }
        catch(e){
            console.log(e)
            if(e instanceof AuthError){
                setIsAuth(false)
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else if(e instanceof MyError){
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else{
                setGlobalMessage({message: 'Ошибка при загрузке чека', type: 'error'})
            }
        }
        finally{
            setIsLoading(false)
        }
    }

    const loaded = (e: ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if(files){
            const file = files[0]
            if(file){
                const formData = new FormData()
                formData.append('receipt', file, file.name)
                onSave(formData)
            }
        }
    }

    return (
        <label className={classes.add}>
            <input onChange={loaded} type="file" accept=".pdf" />
            Загрузить чек
        </label>
    )
}
